function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { dir } from "../../../../eden-styled-helpers";
const SvgTopBottom = styled.svg.withConfig({
  componentId: "sc-18mnlt2-0"
})(["display:block;width:100%;", ";"], props => {
  switch (props.origin) {
    case "bottom":
      return "transform: rotate(180deg);";

    default:
      return "";
  }
});
const SvgStartEnd = styled.svg.withConfig({
  componentId: "sc-18mnlt2-1"
})(["display:block;height:100%;", ";", ""], props => {
  switch (props.origin) {
    case "end":
      return "transform: rotate(180deg) scaleY(-1)";

    default:
      return "";
  }
}, dir("rtl")`
    ${props => {
  switch (props.origin) {
    case "start":
      return "transform: rotate(180deg) scaleY(-1)";

    case "end":
      return "transform: none";

    default:
      return "";
  }
}};
  `);

const Regular = ({
  origin = "top",
  color = "currentColor",
  noShoulder = false,
  ...props
}) => {
  const colorCode = color.replace(/#/, "");
  return origin === "top" || origin === "bottom" ? /*#__PURE__*/React.createElement(SvgTopBottom, _extends({
    origin: origin,
    viewBox: noShoulder ? origin === "top" ? "0 8 40 42" : "0 9 40 25" : "0 0 40 34",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: `eden-light-rays-regular-a-${colorCode}`
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".25",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: `eden-light-rays-regular-b-${colorCode}`
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".35",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".15",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "98.607%",
    y2: "50%",
    id: `eden-light-rays-regular-c-${colorCode}`
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".35",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: `url(#eden-light-rays-regular-a-${colorCode})`,
    transform: "translate(6.824 -6.832)",
    d: "M-6.824 14.832v2.587l39.991 7.756V14.832z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: `url(#eden-light-rays-regular-b-${colorCode})`,
    transform: "translate(-2.957 -.973)",
    d: "M2.957 8.973v25.984l36.07-25.984z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: `url(#eden-light-rays-regular-a-${colorCode})`,
    transform: "translate(4.175 -4.184)",
    d: "M-4.176 12.184v15.64l39.992-15.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: `url(#eden-light-rays-regular-c-${colorCode})`,
    transform: "translate(10.697 -10.705)",
    d: "M-10.697 21.303h39.992v-2.598h-39.992z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    transform: "scale(1,1.05)",
    d: "M40 0v8H0V0z"
  })) : /*#__PURE__*/React.createElement(SvgStartEnd, _extends({
    origin: origin,
    viewBox: noShoulder ? origin === "start" ? "8 0 42 40" : "9 0 25 40" : "0 0 34 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: `eden-light-rays-regular-a-${colorCode}`
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".25",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: `eden-light-rays-regular-b-${colorCode}`
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".35",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".15",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "98.607%",
    y2: "50%",
    id: `eden-light-rays-regular-c-${colorCode}`
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".35",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: `url(#eden-light-rays-regular-a-${colorCode})`,
    d: "M0 0v2.586l39.992 7.757V0z",
    transform: "rotate(-90 24 16)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: `url(#eden-light-rays-regular-b-${colorCode})`,
    d: "M0 0v25.984L36.07 0z",
    transform: "rotate(-90 24 16)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: `url(#eden-light-rays-regular-a-${colorCode})`,
    d: "M0 0v15.641L39.992 0z",
    transform: "rotate(-90 24 16)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: `url(#eden-light-rays-regular-c-${colorCode})`,
    d: "M0 2.598h39.992V0H0z",
    transform: "rotate(-90 24 16)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    transform: "scale(1.05,1)",
    d: "M0 0h8v40H0z"
  }));
};

Regular.propTypes = {
  /** The base color of the light rays */
  color: PropTypes.string,

  /** Whether the leading shoulder spacing should be hidden */
  noShoulder: PropTypes.bool,

  /** Which direction the light rays originate from */
  origin: PropTypes.oneOf(["top", "bottom", "start", "end"])
};
export default Regular;